export const DEFAULT_QUEUES_PER_PAGE = 25;
export const QUEUE_PER_PAGE_OPTIONS = [10, 25, 50, 100];